(function(){
    angular.module('tmx-app').controller('profileLinkEditCtrl', ['$http', '$scope','lookupService', 'CurrentUserService','resolvedData',
        '$state','imageService','$mdToast','APP_CONSTANTS','ProfileLinkService','$location','$anchorScroll','ToastService','TMX_FINANCE_CONSTANTS',ProfileLinkEditCtrl]);

    function ProfileLinkEditCtrl($http, $scope,lookupService, CurrentUserService, resolvedData, $state, imageService,
        $mdToast, APP_CONSTANTS,ProfileLinkService,$location,$anchorScroll,ToastService,TMX_FINANCE_CONSTANTS) {
            /////////////////////////////
        var profileVM = this;

            //initializing Lookup types from Tmx Finance Constant
        var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;


            //password tab data///////////
        var url = APP_CONSTANTS.AuthServer; //for change password
        profileVM.userData={};
            //////////////////////////////
        profileVM.loading = false;
        profileVM.readonly =false;
        profileVM.vm={};
            //profileVM.config = {};

            //getting user data
        profileVM.vm = angular.copy(resolvedData.User.data);
        profileVM.oldVM = angular.copy(profileVM.vm);
            //getting all the other LOV data to be displayed in Dropdowns
            //profileVM.usersList = resolvedData.Users.data;//for Reporting Boss
        profileVM.userTypes = resolvedData.UserTypes;//for User Type

        profileVM.userTypes.forEach(function (type) {
                 
            type.HiddenValue = type.LookupId;
        });


        profileVM.locations = resolvedData.locations.data;//for locations
        profileVM.gridData = resolvedData.locations;
        profileVM.deviceList = resolvedData.Devices.data;
        profileVM.designationsLookup = lookupService.getLocalLookupsByType(lkupType.DESIGNATION);
        var passwordChangedCalled = false;
        var profileSaveCalled = false;

            //A check to see if image already loaded by user
        if(profileVM.vm.ImageUrl != null) {
            $('#ProfilePic').src = profileVM.vm.ImageUrl;
            $('#StudentImgHidden').src = profileVM.vm.ImageUrl;
        }

            //for (var i = resolvedData.locations.data.length - 1; i >= 0; i--) {
				//if(resolvedData.locations.data[i].HiddenValue==profileVM.vm.LocationId){
            //        profileVM.vm.LocationName=resolvedData.locations.data[i].VisibleValue;
            //    }
            //
            //}

            //for (var i = resolvedData.Users.data.length - 1; i >= 0; i--) {
			//	if(resolvedData.Users.data[i].HiddenValue==profileVM.vm.ParentUserId)
             //   {
             //       profileVM.vm.ReportingBoss=resolvedData.Users.data[i].VisibleValue;
             //   }
            //
            //
			//}
            //for (var i = resolvedData.UserTypes.length - 1; i >= 0; i--) {
				//if(resolvedData.UserTypes[i].HiddenValue==profileVM.vm.UserTypeLkp){
            //        profileVM.vm.UserType=resolvedData.UserTypes[i].VisibleValue;
            //    }
            //}

			//for (var i = resolvedData.Devices.data.length - 1; i >= 0; i--)              
			//	if(resolvedData.Devices.data[i].HiddenValue==profileVM.vm.DeviceId)
             //   {
            //
             //       profileVM.vm.DeviceName=resolvedData.Devices.data[i].VisibleValue;
             //   }
            //
            //
			//}
            //if(angular.isDefined(BranchService.lookup.companiesLovs) && BranchService.lookup.companiesLovs.length>0)
            //{
            //    for (var i = BranchService.lookup.companiesLovs.length - 1; i >= 0; i--) {
            //        if(BranchService.lookup.companiesLovs[i].HiddenValue==dataitem.CompanyId)
            //        {
            //            return BranchService.lookup.companiesLovs[i].VisibleValue;
            //        }
            //    }
            //}
            //return "N/A";
            /////////////////////////////  FORM VALIDATION ERRORS//////////////////////////////////////////////////////////////////
        profileVM.getFormErrors = function(){

            if(angular.isDefined(profileVM.dialogForm)) {
                if(profileVM.dialogForm.$invalid ) {
                         
                    return profileVM.dialogForm.$error;
                }
            }
            return undefined;
        };
            ////////////////////////////////////////////////////////////////////////////
        profileVM.errorChanged = function(newErrors,oldErrors){
            if(newErrors!=oldErrors) {
                profileVM.dirtyFormControls = [];
                angular.forEach(profileVM.dialogForm, function(value, key) {
                    if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid)) {
                        profileVM.dirtyFormControls.push(value.$name);
                    }
                });

                profileVM.error_msg = "Required field(s): ";
                for (var i = 0; i < profileVM.dirtyFormControls.length; i++) {
                    if(i==profileVM.dirtyFormControls.length-1) {
                        profileVM.error_msg +=  profileVM.dirtyFormControls[i];
                    }
                    else {
                        profileVM.error_msg +=  profileVM.dirtyFormControls[i] + ", ";
                    }
                }//for end
            }
        };
//////////////////////////////////////////////////////////////////////////////
        $scope.$watch(profileVM.getFormErrors,profileVM.errorChanged,true);
/////////////////////////////////////////////////////////////////////////////////////
            //////////////////////////////////SAVING THE FORM////////////////////////////////////////////////////////
        profileVM.save = function(form) {
                 
            profileVM.loading = true;
            profileSaveCalled = true;
            var imgEle = document.getElementById("StudentImgHidden");
            var imgVis = document.getElementById("ProfilePic");
            profileVM.formSubmitted = true;
            profileVM.bypassForm = false;
            profileVM.errorCount = 0;
            profileVM.formError = false;
            if (form.$invalid){
                profileVM.dirtyFormControls = [];
                profileVM.formInvalid = true;
                profileVM.loading = false;
                angular.forEach(form, function(value, key) {
                         
                    if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid)) {

                             
                        value.$setTouched();
                        profileVM.errorCount++;
                        profileVM.formError = true;
                        profileVM.dirtyFormControls.push(value.$name);

                    }
                });
                if(profileVM.errorCount<=0 && !profileVM.formError)
                    profileVM.bypassForm = true;
            }
            else {

                profileVM.bypassForm = true;

            }
                ////////////////////////////////////////////////////////
            if(!profileVM.bypassForm){
                profileVM.error_msg = "Required field(s): ";
                for (var i = 0; i < profileVM.dirtyFormControls.length; i++) {
                    if(i==profileVM.dirtyFormControls.length-1){
                        profileVM.error_msg +=  profileVM.dirtyFormControls[i];
                    }
                    else{
                        profileVM.error_msg +=  profileVM.dirtyFormControls[i] + ", ";
                    }
                }
                $location.hash('error');
                $anchorScroll.yOffset = 800;
                    // call $anchorScroll()
                $anchorScroll();
            }
            else{
                profileVM.loading = true;

                     
                if(imgEle.src != imgVis.src) {
                         
                    profileVM.vm.ImageData = localStorage.getItem('image');
                    profileVM.vm.ImageUrl = undefined;
                    profileVM.saveOrUpdate();

                }
                else{
                    profileVM.getBase64Image(imgEle).then(profileVM.handleResizedImg, profileVM.rejectResizedImg);
                }

            }
            $scope.oldImage = imgEle;
        };
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        profileVM.cancel = function() {
            $state.go('^', {}, { reload: true });
        };
///////////////////////////CLICKING IMAGE DIV FOR OPENING BROWSER WINDOW//////////////////////////////////////////////
        profileVM.imageChoose=function() {
            document.getElementById('imgFile').click();
        };
////////////////////////////////GETTING BASE 64 IMAGE AND RESIZING IT BEFORE SENDING TO SERVER/////////////////////
        profileVM.getBase64Image=function(imgElem) {
            return(imageService.resize(imgElem, 600, 600));
        };
////////////////////////////////////////SHOWING IMAGE ON EDIT SCREEN//////////////////////////////////////////////
        $scope.showImage = function(fileInput) {
            var files = fileInput.files;
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                var imageType = /image.*/;
                if (!file.type.match(imageType)) {
                    $("#fileError").html("Upload an Image File!");
                    $("#imgFile").val("");
                    continue;
                }
                if (file.size > 1000000) {
                    profileVM.Imgsize = file.size;
                        //$("#fileError").html("WARNING: Your file size is > 1 MB!");
                        //$("#imgFile").val("");
                        //return;
                }
                else {
                    $("#fileError").html("");
                }

                var img = document.getElementById("ProfilePic");
                img.file = file;
                profileVM.vm.ImageUrl=file.name;
                var reader = new FileReader();
                reader.onload = (function (aImg) {
                    return function (e) {
                        aImg.src = e.target.result;
                    };
                })(img);
                reader.readAsDataURL(file);
            }


            var files = fileInput.files;
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                var imageType = /image.*/;
                if (!file.type.match(imageType)) {
                    {

                        continue;
                    }
                }
                var img = document.getElementById("StudentImgHidden");
                img.file = file;


                profileVM.vm.ImageUrl= file.name;
                var reader = new FileReader();
                reader.onload = (function (aImg) {
                    return function (e) {
                        aImg.src = e.target.result;
                    };
                })(img);
                reader.readAsDataURL(file);

            }

            $("#uploadData").html("Update<br/>Photo");
        };
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        profileVM.fadeError = function() {
            $("#fileError").html("");
                 //    $('#fileError').fadeOut('fast');
        };
//////////////////////////////////////////RESIZE SUCCESS FUNCTION///////////////////////////////////////////////////////
        profileVM.handleResizedImg = function(resizedImage){

            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            var imageObj = new Image();
            imageObj.onload = function() {
                var sourceX = 0;
                var sourceY = 0;
                var sourceWidth;
                var sourceHeight;
                if($scope.oldImage.width < resizedImage.width && $scope.oldImage.height < resizedImage.height){
                    sourceWidth = resizedImage.width;
                    sourceHeight = resizedImage.height;
                }
                else {
                    sourceWidth = 600;
                    sourceHeight = 450;
                }

                var destWidth = sourceWidth;
                var destHeight = sourceHeight;

                var destX = 0;//canvasN.width / 2 - destWidth / 2;
                var destY = 0;//canvasN.height / 2 - destHeight / 2;
                canvas.width = destWidth;
                canvas.height = destHeight;
                ctx.drawImage(imageObj, sourceX, sourceY, sourceWidth, sourceHeight, destX, destY, destWidth, destHeight);
                $scope.dataURL = canvas.toDataURL("image/png");


                $scope.dataURL = $scope.dataURL.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
                localStorage.setItem("image", $scope.dataURL);
                profileVM.vm.ImageData = $scope.dataURL;
                profileVM.vm.ImageUrl = undefined;
////////////////////////////////////UPDATING USER DATA//////////////////////////////////////////////////////////////////
                profileVM.vm.$saveOrUpdate().then(function(promise) {
                    profileVM.loading = false;
                         // $state.go("^");
                    if(angular.isDefined(profileVM.userData.ConfirmPassword) && !passwordChangedCalled){
                        profileVM.changePassword();
                    }
                    else{
                        $state.go("^", {"Id": profileVM.vm.UserId})
                            .then(function(t) {
                                $state.reload(t.name);
                            });
                    }//else end
			          });
            };

            imageObj.src = resizedImage.src;

        };
//////////////////////////////////////////////////////////////////////////////////////////////////////////
        profileVM.saveOrUpdate = function(){
            profileVM.vm.TmXAddress = null;
            profileVM.vm.$saveOrUpdate().then(function(promise) {
                profileVM.loading = false;
                    // $state.go("^");
                if(angular.isDefined(profileVM.userData.ConfirmPassword) && !passwordChangedCalled){
                    profileVM.changePassword();
                }
                else{
                    $state.go("^", {"Id": profileVM.vm.UserId})
                        .then(function(t) {
                            $state.reload(t.name);
                        });
                }//else end
            });
        };
////////////////////////////////////////////////ERROR FUNCION////////////////////////////////////////////////////////////
        profileVM.rejectResizedImg = function(){
                 //ServerExceptionService.Displaymsg = "Error Resizing the Picture!";
        };
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        profileVM.changePassword = function(){
            profileVM.loading = true;
            $http.post(url + '/api/account/changepassword', profileVM.userData).then(profileVM.handleSuccess,profileVM.handleError);
        };
        profileVM.handleError = function(data){
            profileVM.loading = false;
        };
        profileVM.handleSuccess = function(data) {

            profileVM.loading = false;
            if (!angular.isDefined(data) || data == null) {
                ToastService.showCustomToast("error", "Some Error Occured");
            }
            else{
                if(data.statusText == "OK"){
                    if(angular.isDefined(data.data.status)) {
                        ToastService.showCustomToast("success",data.data.status.message);
                    }

                }
            }
                // $scope.dataLoading=false;
            passwordChangedCalled = true;
                //profileVM.userData = {};
            if(!angular.equals(profileVM.vm, profileVM.oldVM) && !profileSaveCalled)
                profileVM.save(profileVM.dialogForm);
            else{
            		$state.go("^", {
                    "Id": profileVM.vm.UserId
                }).then(function(t){
                    $state.reload(t.name);

                });
            	}
        };
// (?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z])
        profileVM.strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*-_`~])(?=.{10,})");
	        profileVM.mediumRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*-_`~])(?=.{8,})");
        profileVM.passwordStrength = {
            "float": "left",
            "width": "33%",
            "height": "25px"
        };
        profileVM.analyze = function(value) {
            if(profileVM.strongRegex.test(value)) {
                profileVM.passwordStrength["background-color"] = "green";
                profileVM.passwordStrength["width"] = "100%";
            }
            else if(profileVM.mediumRegex.test(value)) {
                profileVM.passwordStrength["background-color"] = "orange";
                profileVM.passwordStrength["width"] = "66%";
            }
            else {
                profileVM.passwordStrength["background-color"] = "red";
                profileVM.passwordStrength["width"] = "33%";
            }
        };
    }
}

)(); 